import { PerReservation } from "./per-reservation";
import { ReservationPerDate } from "./reservation-per-date";

export const CsvHeaders = {
	reservation: {
		perReservation: PerReservation,
		perDate: ReservationPerDate,
	},
};

export type CsvHeadersType = Array<string>;
